
export const root = {
    borderColor: '{content.border.color}'
};

export const content = {
    background: '{content.background}',
    color: '{text.color}'
};

export const horizontal = {
    margin: '1.125rem 0',
    padding: '0 1.125rem',
    content: {
        padding: '0 0.625rem'
    }
};

export const vertical = {
    margin: '0 1.125rem',
    padding: '1.125rem 0',
    content: {
        padding: '0.625rem 0'
    }
};

export default {
    root,
    content,
    horizontal,
    vertical
};
